












import { Component, Prop, Vue } from 'vue-property-decorator';
import Placeholder from '@/views/account/Placeholder.vue';

@Component({
  components: {Placeholder},
})
export default class AddressField extends Vue {
  @Prop({required: false, default: null})
  private value: any;
  @Prop({required: true, type: String})
  private messageCode!: string;
  @Prop({required: false, default: 'text'})
  private inputType!: string;
  @Prop({required: false, default: true, type: Boolean})
  private fieldRequired!: boolean;

  public onChange(event: any) {
    this.$emit('input', event.target.value);
  }
}
